export default {
  Title: 'Change password',
  EnterPassword: 'New password',
  ConfirmPassword: 'Confirm password',
  PasswordConfirmation: 'Your password and confirmation do not match.',
  PasswordRequired: 'Mandatory field',
  PasswordConfirmationRequired: 'Mandatory field',
  PasswordSubmit: 'Submit',
  PasswordCancel: 'Cancel',
  PasswordClear: 'Clear',
  PasswordRetry: 'Retry',
  PasswordInfoMsg: 'Please enter the desired password for this account',
  PasswordStrength: 'Password strength : ',
  PasswordStrengthVeryStrong: 'VERY STRONG',
  PasswordStrengthStrong: 'STRONG',
  PasswordStrengthWeak: 'WEAK',
  Regle8CharMin: 'Eight or more characters',
  Regle3Element: 'Must contain at least three of the following four elements:',
  RegleLettreMinuscules: 'Lowercase letters',
  RegleLettreMajuscules: 'Uppercase letters',
  RegleChiffre: 'Numbers',
  RegleCharSpec: 'Special characters (@, %, $, !)',
  PasswordError: 'Sorry. An error has occurred. See below.',
  expired: 'Your session has expired.  Please try to sign in again',
};
